import { useMutation } from "@tanstack/react-query";
import { fetchOverdueBills, sendDueReminders } from "../../services/dueReminder";

export const useFetchOverdueBills = () => {
  return useMutation({
    mutationFn: (data) => fetchOverdueBills(data),
  });
};

export const useSendDueReminders = () => {
  return useMutation({
    mutationFn: (data) => sendDueReminders(data),
  });
};
